var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{attrs:{"label":_vm.label,"position":_vm.position}},[_c('a',{class:_vm.classes,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('b-icon',{attrs:{"icon":_vm.icon}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }